/* src/app/shared/components/modals/contact-support/contact-support.component.scss */
.contact-support-field {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
}
.contact-support-field:active,
.contact-support-field:focus,
.contact-support-field:hover {
  --p-inputtext-focus-border-color: var(--brand-warning);
  --p-inputtext-hover-border-color: var(--brand-warning);
  --p-textarea-focus-border-color: var(--brand-warning);
  --p-textarea-hover-border-color: var(--brand-warning);
}
/*# sourceMappingURL=contact-support.component.css.map */
